import React, { Component } from "react"
import { connect } from "react-redux"
import { injectIntl, FormattedMessage } from "react-intl"
import {
  fetchNewSamples,
  updateNewSamplesState,
} from "../../../actions/AspireSamples"
import _ from "underscore"
import classNames from "classnames"
import $ from "jquery"
import Parser from "html-react-parser"
import { sendTrackingData } from "@vmockinc/dashboard/services/tracking"
import { editModalAriaLabel } from "../../Constants/AriaLabelText"
import { fetchCustomisation } from "../../../services/helpers"
import lottie from "lottie-web"
import SampleLoadingAnimation from "./SampleLoadingAnimation"


class SamplesGuide extends Component {


  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      isEdited: false,
    }
    this.sectionSamples = 0
    this.len = 0
    this.hasSampleScrolled = false
    this.handleSampleScroll = this.handleSampleScroll.bind(this)
    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 5000, true)
    this.sendTrackingDataDebounceSampleScrolled = _.debounce(
      sendTrackingData,
      5000,
      true
    )
    this.handleNextSampleClick = this.handleNextSampleClick.bind(this)
    this.handlePrevSampleClick = this.handlePrevSampleClick.bind(this)
    this.getNextButton = this.getNextButton.bind(this)
    this.getPreviousButton = this.getPreviousButton.bind(this)
    this.getSample = this.getSample.bind(this)
    this.imgSamples = {
      urls: [
        `${process.env.APP_BASE_URL}dist/images/img-suggestion-20.png`,
        `${process.env.APP_BASE_URL}dist/images/img-suggestion-21.png`,
        `${process.env.APP_BASE_URL}dist/images/img-suggestion-6.jpg`,
      ],
      feedback: {
        face_frame_ratio: this.props.intl.formatMessage({
          id: "aspire.samplesGuide.faceFrameRatio",
          defaultMessage: "Face/Frame Ratio",
        }),
        face_body_ratio: this.props.intl.formatMessage({
          id: "aspire.samplesGuide.faceBodyRatio",
          defaultMessage: "Face/Body Ratio",
        }),
        background_detection: this.props.intl.formatMessage({
          id: "aspire.samplesGuide.backgroundDetection",
          defaultMessage: "Background Illumination",
        }),
        foreground_detection: this.props.intl.formatMessage({
          id: "aspire.samplesGuide.foregroundDetection",
          defaultMessage: "Foreground Illumination",
        }),
        eye_contact: this.props.intl.formatMessage({
          id: "aspire.samplesGuide.eyeContact",
          defaultMessage: "Eye Contact",
        }),
        smile: this.props.intl.formatMessage({
          id: "aspire.samplesGuide.smileDetection",
          defaultMessage: "Smile Detection",
        }),
      },
    }
  }

  UNSAFE_componentWillMount() {
    const {
      fetchNewSamples,
      currentSection,
      currentIndex,
      fetchId,
      newSubSection,
      isEdited,
      fetchedSamples,
      fetchingSamples,
      errorSamples,
      aspireSamplesSection,
      aspireSamplesSubSection,
      samples,
    } = this.props

    this.setState({ isEdited: isEdited })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { updateEditSection } = nextProps
    if (updateEditSection == true) {
      this.setState({ isEdited: false })
    }
  }

  wrapWithPara(string2, tag = "p") {
    if (!_.isNull(string2) && _.isString(string2)) {
      let output = []
      let string = string2.trim().split(/[\n\r]+/)
      if (tag == "p") {
        for (var i in string) {
          output.push(<p key={"p" + i}>{Parser(string[i].trim())}</p>)
        }
      } else if (tag == "li") {
        for (var i in string) {
          output.push(<li>{Parser(string[i].trim())}</li>)
        }
      }
      return output
    }

    return string2
  }

  replaceNextLinesWithBrTag(string2) {
    let string = ""
    if (!_.isNull(string2) && _.isString(string2)) {
      string = string2.split("\n").join("<br/>")
    }
    return Parser(string)
  }

  handlePrevSampleClick() {
    const { currentSection, currentIndex } = this.props
    if (this.state.index > 0) {
      let jsonObjectForTracking = {
        eventLabel: "previous_sample_btn",
        currentSection: currentSection,
        currentIndex: currentIndex,
        currentSampleIndex: this.state.index,
      }
      this.sendTrackingDataDebounce(
        "event",
        "aspire_edit_screen",
        "click",
        JSON.stringify(jsonObjectForTracking)
      )

      $("#scrollItToTop").scrollTop(0)
      this.setState((prevState) => ({ index: prevState.index - 1 }))
    }
  }

  handleNextSampleClick(len) {
    const { currentSection, currentIndex } = this.props
    if (this.state.index < len - 1) {
      let jsonObjectForTracking = {
        eventLabel: "next_sample_btn",
        currentSection: currentSection,
        currentIndex: currentIndex,
        currentSampleIndex: this.state.index,
      }
      this.sendTrackingDataDebounce(
        "event",
        "aspire_edit_screen",
        "click",
        JSON.stringify(jsonObjectForTracking)
      )

      $("#scrollItToTop").scrollTop(0)
      this.setState((prevState) => ({ index: prevState.index + 1 }))
    }
  }

  renderLoading() {
    const { currentSection, tabIndex } = this.props

    let showSmallSampleAdjustments = false
    if (currentSection == "Education" || currentSection == "Headline") {
      showSmallSampleAdjustments = false
    }

    return <SampleLoadingAnimation />
  }

  renderLoadingError() {
    const { currentSection, tabIndex, intl } = this.props

    let showSmallSampleAdjustments = false
    if (currentSection == "Education" || currentSection == "Headline") {
      showSmallSampleAdjustments = false
    }

    return (
      <div
        className={classNames("as-samples-loader-wrapper", {
          "as-small-samples-loader-wrapper": showSmallSampleAdjustments,
        })}
      >
        <div className="sample-loading-error">
          <div className="as-api-error-img">
            <img
              src={`${process.env.APP_BASE_URL}dist/images/ic_delete_alert.svg`}
              width="70px"
              alt={intl.formatMessage({
                id: "aspire.samplesGuide.loadingErrorHeading",
                defaultMessage: "Some error occurred.",
              })}
              className="sample-fetch-failed"
            />
          </div>
          <div className="text">
            <div
              className="sample-error-heading"
              tabIndex={tabIndex}
              aria-label={intl.formatMessage({
                id: "aspire.samplesGuide.loadingErrorHeading",
                defaultMessage: "Some error occurred.",
              })}
            >
              {intl.formatMessage({
                id: "aspire.samplesGuide.loadingErrorHeading",
                defaultMessage: "Some error occurred.",
              })}
            </div>
            <div
              className="sample-error-subheading"
              tabIndex={tabIndex}
              aria-label={intl.formatMessage({
                id: "aspire.samplesGuide.loadingErrorSubheading",
                defaultMessage: "Please try again later!",
              })}
            >
              {intl.formatMessage({
                id: "aspire.samplesGuide.loadingErrorSubheading",
                defaultMessage: "Please try again later!",
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  getUniqueTemplates(templatesArray) {
    const { currentSection } = this.props
    let arrayOfTemplateIds = []
    let uniquetemplatesArray = _.filter(templatesArray, function (template) {
      if (template.hasOwnProperty("template_id")) {
        let checkIfAlreadyPresent = _.contains(
          arrayOfTemplateIds,
          template.template_id,
        )
        if (!checkIfAlreadyPresent) {
          arrayOfTemplateIds.push(template.template_id)
          return true
        } else {
          return false
        }
      }
      return true
    })

    if (currentSection !== "Education") {
      // swap 1st and 2nd templates
      if (uniquetemplatesArray.length > 1) {
        let temp = uniquetemplatesArray[0]
        uniquetemplatesArray[0] = uniquetemplatesArray[1]
        uniquetemplatesArray[1] = temp
      }
    }

    uniquetemplatesArray = _.map(uniquetemplatesArray, function (template) {
      let sampleHeading = ""
      if (template["template_id"] == 1) {
        sampleHeading = "First Person"
      } else if (template["template_id"] == 2) {
        sampleHeading = "Competency Focused"
      } else if (template["template_id"] == 3) {
        sampleHeading = "Section Focused"
      }
      return _.extend({}, template, { heading: sampleHeading })
    })

    return uniquetemplatesArray
  }

  handleSampleScroll() {
    const { currentSection, currentIndex } = this.props
    if (!this.hasSampleScrolled) {
      this.hasSampleScrolled = true
      let jsonObjectForTracking = {
        eventLabel: "sample_scrolled",
        currentSection: currentSection,
        currentIndex: currentIndex,
        currentSampleIndex: this.state.index,
      }
      this.sendTrackingDataDebounceSampleScrolled(
        "event",
        "aspire_edit_screen",
        "click",
        JSON.stringify(jsonObjectForTracking),
      )
    }
  }

  handleDotClick(index) {
    const { currentSection, currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: "sample_dot_clicked",
      currentSection: currentSection,
      currentIndex: currentIndex,
      clickedSampleIndex: index,
    }
    this.sendTrackingDataDebounce(
      "event",
      "aspire_edit_screen",
      "click",
      JSON.stringify(jsonObjectForTracking),
    )
    this.setState({ index: index })
  }

  getIndicatorDots(index, len) {
    let dots = []
    for (let i = 0; i < len; i++) {
      if (i == index) {
        dots.push(
          <div
            key={i}
            className="as-sample-indicator-dots as-sample-indicator-dots-light"
          />,
        )
      } else {
        dots.push(
          <div
            key={i}
            className="as-sample-indicator-dots as-sample-indicator-dots-dark"
            onClick={() => this.handleDotClick(i)}
          />,
        )
      }
    }

    return <div className="as-headline-suggestions-indicator">{dots}</div>
  }

  getPreviousButton(index, len) {
    const { intl } = this.props
    if (index !== 0) {
      return (
        <button
          className="as-sample-btn as-sample-btn-prev"
          onClick={() => this.handlePrevSampleClick()}
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)["previous_sample"]}
        >
          <span className="arrow arrow-left" />
        </button>
      )
    } else {
      return (
        <button
          tabIndex={-1}
          className="as-sample-btn as-sample-btn-prev disabled"
          aria-label={editModalAriaLabel(intl)["previous_sample"] + ' disabled'}
          disabled
        >
          <span className="arrow arrow-left" />
        </button>
      )
    }
  }

  getNextButton(index, len) {
    const { intl } = this.props
    if (index !== len - 1) {
      return (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)["next_sample"]}
          className="as-sample-btn as-sample-btn-next"
          onClick={() => this.handleNextSampleClick(len)}
        >
          <span className="arrow arrow-right" />
        </button>
      )
    } else {
      return (
        <button
          tabIndex={-1}
          className="as-sample-btn as-sample-btn-next disabled"
          aria-label={editModalAriaLabel(intl)["next_sample"] + ' disabled'}
          disabled
        >
          <span className="arrow arrow-right" />
        </button>
      )
    }
  }
  getPreviousButtonForProfilePicture(index, len) {
    const { intl } = this.props
    if (index !== 0) {
      return (
        <button
          tabIndex={0}
          aria-label={intl.formatMessage({
            id: "aspire.samplesGuide.profilePicturePreviousSampleAriaLabel",
            defaultMessage: "Click to view previous sample",
          })}
          className="as-profile-picture-sample-btn as-profile-picture-sample-btn-prev"
          type="button"
          onClick={() => this.handlePrevSampleClick()}
        >
          <span className="arrow arrow-left" />
        </button>
      )
    } else {
      return (
        <button
          tabIndex={-1}
          className="as-profile-picture-sample-btn as-profile-picture-sample-btn-prev disabled"
          aria-label={intl.formatMessage({
            id: "aspire.samplesGuide.profilePicturePreviousSampleDisabledAriaLabel",
            defaultMessage: "Click to view previous sample, disabled",
          })}
        >
          <span className="arrow arrow-left" />
        </button>
      )
    }
  }
  getNextButtonForProfilePicture(index, len) {
    const { intl } = this.props
    if (index !== len - 1) {
      return (
        <button
          tabIndex={0}
          type="button"
          aria-label={intl.formatMessage({
            id: "aspire.samplesGuide.profilePictureNextSampleAriaLabel",
            defaultMessage: "Click to see the next sample",
          })}
          className="as-profile-picture-sample-btn as-profile-picture-sample-btn-next"
          onClick={() => this.handleNextSampleClick(len)}
        >
          <span className="arrow arrow-right" />
        </button>
      )
    } else {
      return (
        <button
          tabIndex={-1}
          className="as-profile-picture-sample-btn as-profile-picture-sample-btn-next disabled"
          aria-label={intl.formatMessage({
            id: "aspire.samplesGuide.profilePictureNextSampleDisabledAriaLabel",
            defaultMessage: "Click to see the next sample, disabled",
          })}
        >
          <span className="arrow arrow-right" />
        </button>
      )
    }
  }

  getSample(currentSection, index, sectionSamples) {
    if (currentSection == "Experience") {
      if (_.isObject(sectionSamples[index]["template"])) {
        return (
          <div
            className="as-sample-example-text as-sample-example-text-experience"
            id="scrollItToTop"
            onScroll={this.handleSampleScroll}
          >
            <h3>{sectionSamples[index]["template"]["title"]}</h3>
            <p>{sectionSamples[index]["template"]["sub_title"]}</p>
            <p> {sectionSamples[index]["template"]["duration"]}</p>
            {this.wrapWithPara(sectionSamples[index]["template"]["body"])}
          </div>
        )
      } else {
        return (
          <div
            className="as-sample-example-text as-sample-example-text-experience"
            id="scrollItToTop"
            onScroll={this.handleSampleScroll}
          >
            <p>
              {this.replaceNextLinesWithBrTag(
                sectionSamples[index]["template"],
              )}
            </p>
          </div>
        )
      }
    } else if (currentSection == "Summary") {
      return (
        <div
          className="as-sample-example-text as-sample-example-text-summary"
          id="scrollItToTop"
          onScroll={this.handleSampleScroll}
        >
          <p>
            {this.replaceNextLinesWithBrTag(sectionSamples[index]["template"])}
          </p>
        </div>
      )
    } else if (currentSection == "Education") {
      return (
        <div
          className="as-sample-example-text-education"
          id="scrollItToTop"
          onScroll={this.handleSampleScroll}
        >
          <div className="sample-eduaction-title">
            {this.sectionSamples[this.state.index]["template"]["title"]}
          </div>
          <div className="sample-eduaction-sub-title">
            {this.sectionSamples[this.state.index]["template"]["sub_title"]}
          </div>
          <div className="sample-eduaction-duration">
            {" "}
            {this.sectionSamples[this.state.index]["template"]["duration"]}
          </div>
          {this.wrapWithPara(
            this.sectionSamples[this.state.index]["template"]["body"],
          )}
        </div>
      )
    }

    return null
  }

  getProfilePictureSamples() {
    const { user, hideSmileAndFBRatio = false, intl } = this.props
    const { community } = user
    this.len = this.imgSamples["urls"].length
    const feedbackParams = this.imgSamples.feedback
    if (community === "ensign") {
      delete feedbackParams.background_detection
    }
    if (hideSmileAndFBRatio) {
      delete feedbackParams.face_body_ratio
      delete feedbackParams.smile
    }

    return (
      <div className="as-guide-container-picture">
        <div className="as-edit-heading-picture">
          <span
            tabIndex={0}
            aria-label={editModalAriaLabel(intl)["profile_picture"]["sample"]}
          >
            {intl.formatMessage({
              id: "aspire.samplesGuide.profilePictureSampleSuggestionsHeading",
              defaultMessage: "Sample Suggestions",
            })}
          </span>
        </div>
        <div className="as-picture-sample-wrapper">
          <div className="as-picture-sample-img-container">
            <div className="as-picture-bg-color" />
            {this.getPreviousButtonForProfilePicture(
              this.state.index,
              this.len,
            )}
            <div className="as-picture-sample-pic">
              {" "}
              <img
                alt=""
                src={this.imgSamples["urls"][this.state.index]}
                className="suggestion-profile-img"
                height="200"
                width="200"
              />{" "}
            </div>
            {this.getNextButtonForProfilePicture(this.state.index, this.len)}
          </div>
          <div className="as-picture-sample-feedback-container">
            {_.map(feedbackParams, (value, key) => (
              <div key={key} className="as-picture-sample-feedback-tile">
                <div className="as-picture-parameter-status-icon">
                  <img
                    alt=""
                    src={`${process.env.APP_BASE_URL}dist/images/icon-good-job.svg`}
                    className="as-picture-feedback-parameter-icon"
                    height="20"
                    width="20"
                  />
                </div>
                <div className="as-picture-feedback-parameter-text">
                  {value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      showHeading,
      showSubHeading,
      currentSection,
      fetchingSamples,
      fetchedSamples,
      errorSamples,
      samples,
      aspireSamplesData,
      intl,
    } = this.props

    let sample = null
    let heading = null
    let showSmallSampleAdjustments = false

    if (currentSection == "Profile Picture") {
      return this.getProfilePictureSamples()
    }

    if (currentSection == "Education" || currentSection == "Headline") {
      showSmallSampleAdjustments = false
    }
    let headingText = intl.formatMessage({
      id: "aspire.samplesGuide.sampleIllustrationsHeading",
      defaultMessage: "Sample Illustrations",
    })
    if (currentSection == "Summary") {
      headingText = intl.formatMessage({
        id: "aspire.samplesGuide.summaryHeading",
        defaultMessage: "Summary generated for you",
      })
    } else if (currentSection == "Experience") {
      headingText = intl.formatMessage({
        id: "aspire.samplesGuide.experienceHeading",
        defaultMessage: "Suggestion for you",
      })
    }

    if (showHeading == true) {
      heading = (
        <div className="as-guide-heading-wrapper">
          <div className="as-guide-heading-img-wrapper">
            <img
              src={`${process.env.APP_BASE_URL}dist/images/edit-screens/sample-heading-icon.svg`}
              alt=""
              className="as-guide-heading-img"
            />{" "}
          </div>
          <div className="as-guide-heading-text">{headingText}</div>
        </div>
      )
    }

    if (currentSection == "Education") {
      heading = (
        <div className="as-all-lists-heading-wrapper">
          <div className="as-all-lists-heading-img-wrapper">
            <img
              src={`${process.env.APP_BASE_URL}dist/images/edit-screens/headline-sample-heading-icon.svg`}
              alt=""
              className="as-all-lists-heading-img"
            />{" "}
          </div>
          <div className="as-all-lists-heading-text">
            <span
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: "aspire.samplesGuide.educationHeading",
                defaultMessage: "Here are few sample suggestions for you",
              })}
            >
              {intl.formatMessage({
                id: "aspire.samplesGuide.educationHeading",
                defaultMessage: "Here are few sample suggestions for you",
              })}
            </span>
          </div>
        </div>
      )
    }

    if (fetchedSamples && !fetchingSamples && !errorSamples) {
      this.sectionSamples = this.getUniqueTemplates(samples)
      this.len = this.sectionSamples.length

      let template = this.getSample(
        currentSection,
        this.state.index,
        this.sectionSamples,
      )
      let subHeading = null

      if (showSubHeading == true) {
        subHeading = (
          <div className="as-sample-heading">
            {this.sectionSamples[this.state.index]["heading"]}
          </div>
        )
      }

      sample = (
        <>
          <div
            className={classNames("as-sample-wrapper as-sample-wrapper-div ", {
              "as-small-sample-wrapper": showSmallSampleAdjustments,
            })}
          >
            <div className="as-sample-change-left">
              <div
                className={`as-sample-bottom-change-headline ${
                  this.len === 1 ? "hide-btn" : ""
                }`}
              >
                {this.getPreviousButton(this.state.index, this.len)}
              </div>
              <div className="clearfix" />
            </div>
            {/*{heading}*/}
            <div
              className={classNames("as-sample-example as-sample-example-div", {
                "as-small-sample-example": showSmallSampleAdjustments,
              })}
            >
              {subHeading}
              {template}
            </div>
            <div className="as-sample-change-right">
              <div
                className={`as-sample-bottom-change-headline ${
                  this.len === 1 ? "hide-btn" : ""
                }`}
              >
                {this.getNextButton(this.state.index, this.len)}
              </div>
              <div className="clearfix" />
            </div>
          </div>
          <div className="as-sample-change-headline">
            <div
              className={`as-sample-bottom-buttons-headline ${
                this.len === 1 ? "hide-btn" : ""
              }`}
            >
              {this.getIndicatorDots(this.state.index, this.len)}
            </div>
            <div className="clearfix" />
          </div>
        </>
      )
    } else if (fetchedSamples && !fetchingSamples && errorSamples) {
      sample = this.renderLoadingError()
    } else {
      sample = this.renderLoading()
    }

    return (
      <div
        className={classNames("as-guide-container", {
          "as-small-guide-container": showSmallSampleAdjustments,
        })}
      >
        {sample}
      </div>
    )
  }

  componentWillUnmount() {
    const { updateNewSamplesState } = this.props
    window.removeEventListener("scroll", this.handleSampleScroll)
  }
}

function mapStateToProps(state, ownProps) {
  return {
    fetchingSamples: state.aspireSamplesData.fetching,
    fetchedSamples: state.aspireSamplesData.fetched,
    errorSamples: state.aspireSamplesData.error,
    samples: state.aspireSamplesData.samples,
    aspireSamplesSection: state.aspireSamplesData.section,
    aspireSamplesSubSection: state.aspireSamplesData.subSection,
    hideSmileAndFBRatio: fetchCustomisation(
      state.AspireCommunityCustomization.data,
      "hide_smile_&_face_to_body_feedback",
    ),
    user: state.user.data,
  }
}

export default connect(mapStateToProps, {
  fetchNewSamples,
  updateNewSamplesState,
})(injectIntl(SamplesGuide))
